import React from "react";
import { Bar } from "react-chartjs-2";
import { useCentralStore } from "../../../store/appContext";
import { sortByMonthsSalesReport } from "../../../utils/functionUtils";

const SalesBusinessReport = ({ salesReportData }) => {
    const [{ carrierThemeData, userData, userDetails, projectName }, dispatch] = useCentralStore()
    const { theme } = carrierThemeData;

    // const getUniqueChurnByRateValues = (arr) => {
    //     const uniqueYears = [...new Set(arr)];
    //     return uniqueYears;
    // };

    // let salesMonth = getUniqueChurnByRateValues(salesReportData?.map(v => v?.Months));
    // let _salesMonth = salesMonth?.map(str => str.slice(0, -2) + '-' + str.slice(-2))


    // const getSalesReportData = (sales, Category) => {
    //     let data = []
    //     for (let i = 0; i < sales?.length; i++) {
    //         let c = salesReportData?.filter(v => sales[i] === v?.Months)?.[0]
    //         data.push(c?.[Category] || 0)
    //     }
    //     return data
    // }

    // let salesReportDataset = []
    // let category = ['GrossAdd', 'Renewal', 'Churn']

    // category?.map((v, i) => {
    //     salesReportDataset?.push({
    //         label: v,
    //         data: getSalesReportData(salesMonth, v),
    //         fill: true,
    //         backgroundColor: theme?.colors?.monthlyTrendsTab?.chartColors[i],
    //         borderColor: theme?.colors?.monthlyTrendsTab?.chartColors[i]
    //     })
    // })

    // const salesReportChartData = {
    //     labels: _salesMonth,
    //     datasets: salesReportDataset
    // };

    // const SalesReportOptions = {
    //     plugins: {
    //         title: {
    //             display: false,
    //             text: '',
    //         },
    //         datalabels: {
    //             formatter: function (value, context) {
    //                 // return value > 0 ? value+'%' : null;
    //             },
    //             align: "top",
    //             anchor: "end",
    //             clamp: false,
    //             labels: {
    //                 usePointStyle: true,
    //                 font: {
    //                     weight: 300,
    //                     color: 'black',
    //                     size: 10,
    //                 }
    //             },
    //         }
    //     },
    //     responsive: true,
    //     scales: {
    //         x: {
    //             stacked: false,
    //         },
    //         y: {
    //             stacked: false,
    //         },
    //     },
    // };
    const SI_SYMBOLS = ["", "k", "M", "G", "T", "P", "E"];
    const SHORT_SYMBOLS = ["", "K", "M", "B", "T", "Q"];
    const LONG_SYMBOLS = ["", " thousand", " million", " billion", " trillion", " quadrillion"];

const abbreviateNumberFactory = (symbols) => (
  (number, minDigits, maxDigits) => {

      if (number >= 0.01 && number <= 0.99) return number;

      if (number === 0) return number;

      // determines SI symbol
      const tier = Math.floor(Math.log10(Math.abs(number)) / 3);

      // get suffix and determine scale
      const suffix = symbols[tier];
      const scale = 10 ** (tier * 3);

      // scale the number
      const scaled = number / scale;

      // format number and add suffix
      return scaled.toLocaleString(undefined, {
          minimumFractionDigits: minDigits,
          maximumFractionDigits: maxDigits,
      }) + suffix;
  }
);

    // const abbreviateNumberSI = abbreviateNumberFactory(SI_SYMBOLS);
    const abbreviateNumberShort = abbreviateNumberFactory(SHORT_SYMBOLS);
    let abbreviateNumberShortConvert = (value) => {
        return value ? abbreviateNumberShort(value, 0, 2) : 0;
    }

    const getUniqueChurnByRateValues = (arr) => {
        const uniqueYears = [...new Set(arr)];
        return uniqueYears;
    };

    let _salesBusinessReportMonthlyTrend = salesReportData?.salesBusinessReportMonthlyTrend;
    let _salesBusinessReportMonths = _salesBusinessReportMonthlyTrend?.map(v => v?.Months?.replace(/(.{2}$)/, '-$1'));
    let grossAdd = _salesBusinessReportMonthlyTrend?.map(v => v?.GrossAdd);
    let renewal = _salesBusinessReportMonthlyTrend?.map(v => v?.Renewal);
    let churn = _salesBusinessReportMonthlyTrend?.map(v => v?.Chrun);
    let netAdd = _salesBusinessReportMonthlyTrend?.map(v => v?.NetAdd);

    const GrossAddData = {
        labels: _salesBusinessReportMonths,
        datasets: [{
            label: 'Gross Add',
            data: grossAdd,
            fill: true,
            backgroundColor: '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors),
            borderColor: '#001871'//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors)
        }]
    };

    const GrossAddOptions = {
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Gross Add',
                align: 'start',
                font: {
                    size: 20,
                },
                padding: {
                  bottom: 40
                }
            },
            datalabels: {
                formatter: function (value, context) {
                    // return value > 0 ? value + '%' : null;
                    return abbreviateNumberShortConvert(value, 0, 2);
                },
                align: function (value, context) {
                    return Number(value?.dataset?.label) % 2 === 0 ? 'top' : 'bottom'
                },
                font: {
                    size: 10,
                  },
                align: "top",
                // rotation: '-85',
                anchor: "end",
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: "black",
                        size: 14,
                    },
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        barThickness: 15
    };

    const RenewalData = {
        labels: _salesBusinessReportMonths,
        datasets: [{
            label: 'Renewal',
            data: renewal,
            fill: true,
            backgroundColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors),
            borderColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors)
        }]
    };

    const RenewalOptions = {
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Renewal',
                align: 'start',
                font: {
                    size: 20,
                },
                padding: {
                  bottom: 40
                }
            },
            datalabels: {
                formatter: function (value, context) {
                    // return value > 0 ? value + '%' : null;
                    return abbreviateNumberShortConvert(value, 0, 2);
                },
                align: function (value, context) {
                    return Number(value?.dataset?.label) % 2 === 0 ? 'top' : 'bottom'
                },
                font: {
                    size: 10,
                  },
                align: "top",
                // rotation: '-85',
                anchor: "end",
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: "black",
                        size: 14,
                    },
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        barThickness: 15
    };

    const ChurnData = {
        labels: _salesBusinessReportMonths,
        datasets: [{
            label: 'Churn',
            data: churn,
            fill: true,
            backgroundColor: '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors),
            borderColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors)
        }]
    };

    const ChurnOptions = {
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Churn',
                align: 'start',
                font: {
                    size: 20,
                },
                padding: {
                  bottom: 40
                }
            },
            datalabels: {
                formatter: function (value, context) {
                    // return value > 0 ? value + '%' : null;
                    return abbreviateNumberShortConvert(value, 0, 2);
                },
                align: function (value, context) {
                    return Number(value?.dataset?.label) % 2 === 0 ? 'top' : 'bottom'
                },
                font: {
                    size: 10,
                  },
                align: "top",
                // rotation: '-85',
                anchor: "end",
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: "black",
                        size: 14,
                    },
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        barThickness: 15
    };

    const NetAddData = {
        labels: _salesBusinessReportMonths,
        datasets: [{
            label: 'NetAdd',
            data: netAdd,
            fill: true,
            backgroundColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors),
            borderColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors)
        }]
    };

    const NetAddOptions = {
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Net Add',
                align: 'start',
                font: {
                    size: 20,
                },
                padding: {
                  bottom: 40
                }
            },
            datalabels: {
                formatter: function (value, context) {
                    // return value > 0 ? value + '%' : null;
                    return abbreviateNumberShortConvert(value, 0, 2);
                },
                align: function (value, context) {
                    return Number(value?.dataset?.label) % 2 === 0 ? 'top' : 'bottom'
                },
                align: "top",
                // rotation: '-85',
                font: {
                    size: 10,
                  },
                anchor: "end",
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: "black",
                        size: 14,
                    },
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        barThickness: 15
    };

    let churnRateClosingBase = salesReportData?.salesBusinessChurnClosingMonthlyTrend;
    // console.log('_churnRateClosingBase', _churnRateClosingBase);
    
    // const churnRateClosingBase = sortByMonthsSalesReport(_churnRateClosingBase);
    
    let churnRateClosingBaseMonths = churnRateClosingBase?.map(v => v?.Months?.replace(/(.{2}$)/, '-$1'));
    let churnByRate = churnRateClosingBase?.map(v => v?.ChurnRate);
    let ClosingBase = churnRateClosingBase?.map(v => v?.ClosingBase);

    const ChurnRateData = {
        labels: churnRateClosingBaseMonths,
        datasets: [{
            label: 'Churn Rate',
            data: churnByRate,
            fill: true,
            backgroundColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors),
            borderColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors)
        }]
    };

    const ChurnRateOptions = {
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Churn Rate',
                align: 'start',
                font: {
                    size: 20,
                },
                padding: {
                  bottom: 40
                }
            },
            datalabels: {
                formatter: function (value, context) {
                    return value > 0 ? value + '%' : null;
                },
                align: function (value, context) {
                    return Number(value?.dataset?.label) % 2 === 0 ? 'top' : 'bottom'
                },
                font: {
                    size: 10,
                  },
                align: "top",
                anchor: "end",
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: "black",
                        size: 14,
                    },
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        barThickness: 15
    };

    const ClosingBaseData = {
        labels: churnRateClosingBaseMonths,
        datasets: [{
            label: 'Closing Sub',
            data: ClosingBase,
            fill: true,
            backgroundColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors),
            borderColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors)
        }]
    };

    const ClosingBaseOptions = {
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Closing Sub',
                align: 'start',
                font: {
                    size: 20,
                },
                padding: {
                  bottom: 40
                }
            },
            datalabels: {
                formatter: function (value, context) {
                    // return value > 0 ? value + '%' : null;
                    return abbreviateNumberShortConvert(value, 0, 2);
                },
                align: function (value, context) {
                    return Number(value?.dataset?.label) % 2 === 0 ? 'top' : 'bottom'
                },
                font: {
                    size: 10,
                  },
                align: "top",
                // rotation: '-85',
                anchor: "end",
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: "black",
                        size: 14,
                    },
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        barThickness: 15
    };

    const sortByMonths = (data) => {
        return data?.sort((a, b) => new Date(a.Months) - new Date(b.Months));
    };

    let _salesTrainingMonthlyReport = salesReportData?.salesTrainingMonthlyReport;
    
    let newJoinerData = _salesTrainingMonthlyReport?.filter(v => v?.TrainingCategory === 'New Joiner');
    const sortNewJoinerData = sortByMonths(newJoinerData);
    let _newJoinerMonths = sortNewJoinerData?.map(v => v?.Months?.replace(/(.{2}$)/, '-$1'));
    let _newJoinerVolume = sortNewJoinerData?.map(v => v?.Volume);

    const NewJoinerData = {
        labels: _newJoinerMonths,
        datasets: [{
            label: 'New Joiner',
            data: _newJoinerVolume,
            fill: true,
            backgroundColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors),
            borderColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors)
        }]
    };

    const NewJoinerOptions = {
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'New Joiner',
                align: 'start',
                font: {
                    size: 20,
                },
                padding: {
                  bottom: 40
                }
            },
            datalabels: {
                formatter: function (value, context) {
                    // return value > 0 ? value + '%' : null;
                },
                align: function (value, context) {
                    return Number(value?.dataset?.label) % 2 === 0 ? 'top' : 'bottom'
                },
                align: "top",
                anchor: "end",
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: "black",
                        size: 14,
                    },
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        barThickness: 15
    };

    let refreshTrainerData = _salesTrainingMonthlyReport?.filter(v => v?.TrainingCategory === 'Refersher Training');
    const sortRefreshTrainerData = sortByMonths(refreshTrainerData);
    let _refreshTrainerMonths = sortRefreshTrainerData?.map(v => v?.Months?.replace(/(.{2}$)/, '-$1'));
    let _refreshTrainerVolume = sortRefreshTrainerData?.map(v => v?.Volume);

    const RefreshTrainerData = {
        labels: _refreshTrainerMonths,
        datasets: [{
            label: 'Refresher',
            data: _refreshTrainerVolume,
            fill: true,
            backgroundColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors),
            borderColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors)
        }]
    };

    const RefreshTrainerOptions = {
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Refresher Training',
                align: 'start',
                font: {
                    size: 20,
                },
                padding: {
                  bottom: 40
                }
            },
            datalabels: {
                formatter: function (value, context) {
                    // return value > 0 ? value + '%' : null;
                },
                align: function (value, context) {
                    return Number(value?.dataset?.label) % 2 === 0 ? 'top' : 'bottom'
                },
                align: "top",
                anchor: "end",
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: "black",
                        size: 14,
                    },
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        barThickness: 15
    };

    let trainTrainerData = _salesTrainingMonthlyReport?.filter(v => v?.TrainingCategory === 'Train The Trainer');
    const sortTrainTrainerData = sortByMonths(trainTrainerData);
    let _trainTrainerMonths = sortTrainTrainerData?.map(v => v?.Months?.replace(/(.{2}$)/, '-$1'));
    let _trainTrainerVolume = sortTrainTrainerData?.map(v => v?.Volume);

    const TrainTrainerData = {
        labels: _trainTrainerMonths,
        datasets: [{
            label: 'Train The Trainer',
            data: _trainTrainerVolume,
            fill: true,
            backgroundColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors),
            borderColor:  '#001871',//Object.values(theme?.colors?.monthlyTrendsTab?.chartColors)
        }]
    };

    const TrainTrainerOptions = {
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Train The Trainer',
                align: 'start',
                font: {
                    size: 20,
                },
                padding: {
                  bottom: 40
                }
            },
            datalabels: {
                formatter: function (value, context) {
                    // return value > 0 ? value + '%' : null;
                },
                align: function (value, context) {
                    return Number(value?.dataset?.label) % 2 === 0 ? 'top' : 'bottom'
                },
                align: "top",
                anchor: "end",
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: "black",
                        size: 14,
                    },
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        barThickness: 15
    };

    return (
        <>
            <div className={`flex flex-wrap gap-5 ${projectName.replace(/\s+/g, '')}`}>
                <div className='flex flex-col items-center w-full border border-[#D9D9D9] rounded-lg p-4 pb-0'>
                    {/* <p className='p-2 w-full text-black font-bold'>Gross Add</p> */}
                    <div className='w-full'>
                        <Bar options={GrossAddOptions} data={GrossAddData} />
                    </div>
                </div>
                <div className='flex flex-col items-center w-full border border-[#D9D9D9] rounded-lg p-4 pb-0'>
                    {/* <p className='p-2 w-full text-black font-bold'>Renewal</p> */}
                    <div className='w-full'>
                        <Bar options={RenewalOptions} data={RenewalData} />
                    </div>
                </div>
                <div className='flex flex-col items-center w-full border border-[#D9D9D9] rounded-lg p-4 pb-0'>
                    {/* <p className='p-2 w-full text-black font-bold'>Churn</p> */}
                    <div className='w-full'>
                        <Bar options={ChurnOptions} data={ChurnData} />
                    </div>
                </div>
                <div className='flex flex-col items-center w-full border border-[#D9D9D9] rounded-lg p-4 pb-0'>
                    {/* <p className='p-2 w-full text-black font-bold'>Churn Rate</p> */}
                    <div className='w-full'>
                        <Bar options={ChurnRateOptions} data={ChurnRateData} />
                    </div>
                </div>
                <div className='flex flex-col items-center w-full border border-[#D9D9D9] rounded-lg p-4 pb-0'>
                    {/* <p className='p-2 w-full text-black font-bold'>Net Add</p> */}
                    <div className='w-full'>
                        <Bar options={NetAddOptions} data={NetAddData} />
                    </div>
                </div>
                <div className='flex flex-col items-center w-full border border-[#D9D9D9] rounded-lg p-4 pb-0'>
                    {/* <p className='p-2 w-full text-black font-bold'>Closing Sub</p> */}
                    <div className='w-full'>
                        <Bar options={ClosingBaseOptions} data={ClosingBaseData} />
                    </div>
                </div>
                {newJoinerData?.length > 0 &&
                    <div className='flex flex-col items-center w-full border border-[#D9D9D9] rounded-lg p-4 pb-0'>
                        {/* <p className='p-2 w-full text-black font-bold'>Closing Sub</p> */}
                        <div className='w-full'>
                            <Bar options={NewJoinerOptions} data={NewJoinerData} />
                        </div>
                    </div>
                }
                {refreshTrainerData?.length > 0 &&
                    <div className='flex flex-col items-center w-full border border-[#D9D9D9] rounded-lg p-4 pb-0'>
                        {/* <p className='p-2 w-full text-black font-bold'>Closing Sub</p> */}
                        <div className='w-full'>
                            <Bar options={RefreshTrainerOptions} data={RefreshTrainerData} />
                        </div>
                    </div>
                }
                {trainTrainerData?.length > 0 &&
                    <div className='flex flex-col items-center w-full border border-[#D9D9D9] rounded-lg p-4 pb-0'>
                        {/* <p className='p-2 w-full text-black font-bold'>Closing Sub</p> */}
                        <div className='w-full'>
                            <Bar options={TrainTrainerOptions} data={TrainTrainerData} />
                        </div>
                    </div>
                }
            </div>
        </>
    );
}

export default SalesBusinessReport